import { produce } from "immer";
import { Store } from "reducers/rootReducer";

/* STATE */
type State = {
  visible: boolean;
};

const initialState: State = {
  visible: false,
};

/* ACTIONS */
const SHOW_FILTER_MENU = "SHOW_FILTER_MENU";
const HIDE_FILTER_MENU = "HIDE_FILTER_MENU";

type Action =
  | { type: typeof SHOW_FILTER_MENU }
  | { type: typeof HIDE_FILTER_MENU };

/* REDUCER */
export default function reducer(state = initialState, action: Action): State {
  return produce(state, draft => {
    switch (action.type) {
      case SHOW_FILTER_MENU:
        draft.visible = true;
        break;
      case HIDE_FILTER_MENU:
        draft.visible = false;
        break;
    }
  });
}

/* ACTION CREATORS */
export const showFilterMenu = (): Action => ({
  type: SHOW_FILTER_MENU,
});

export const hideFilterMenu = (): Action => ({
  type: HIDE_FILTER_MENU,
});

/* SELECTORS */
export const selectFilterVisible = (app: Store) => app.filterMenu.visible;
